export default "__VITE_ASSET__BbcW52wZ__"